import styled from 'styled-components';
const Image = ({ src, alt, width, margin }) => {
  return (
    <Wrapper width={width}>
      <ImageWrapper src={src} alt={alt} margin={margin} />
    </Wrapper>
  );
};

export default Image;
const Wrapper = styled.div`
  border: 4px dashed #4e6e29;
  border-radius: 4px;
  height: 70%;
  width: ${(props) => (props.width ? props.width : '63%;')};
`;
export const ImageWrapper = styled.img`
  margin: ${(props) => (props.margin ? props.margin : '25px -25px;')};
  border-radius: 4px;
`;
